import React from 'react';
import {array, bool, func, object, string} from 'prop-types';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import { get } from 'lodash';

import {connect} from 'react-redux';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import EsmsDialog from '../../components/EsmsDialog';

import * as WizardActions from '../../actions/wizardActions';

import classes from './EditEntityModal.module.css';

const ValidationSchema = Yup.object().shape({
    equipment: Yup.string()
});

const DEFAULT_FORM_VALUES = {
    equipment: ''
};

const InitialValues = {...DEFAULT_FORM_VALUES};

const UseExistingEquipmentModal = ({
    close,
    device,
    equipment,
    open,
    title,
    toggleLoading,
    ...props
}) => {

    const formik = useFormik({
        initialValues:      InitialValues,
        validationSchema:   ValidationSchema,
        enableReinitialize: true,
        onSubmit:           async (values, { setSubmitting }) => {
            const {
                updateTargetDevices
            } = props;

            setSubmitting(true);

            const targetEquipment = equipment.find(item => item.id === values.equipment);

            device.name = get(targetEquipment, 'name', '');
            device.equipmentType = get(targetEquipment, 'equipmentType.id', '');
            device.manufacturer = get(targetEquipment, 'manufacturer.id', '');
            device.modelNumber = get(targetEquipment, 'model', '');
            device.serialNumber = get(targetEquipment, 'serialNumber', '');
            device.equipmentId = get(targetEquipment, 'id', '');
            device.useExisting = true;

            updateTargetDevices(device);

            setSubmitting(false);

            handleClose();
        }
    });

    const handleReset = () => {
        if (InitialValues.equipment.length) {
            Object.assign(InitialValues, DEFAULT_FORM_VALUES);
        }

        InitialValues.equipment = get(device, 'equipmentId', '');

        formik.handleReset(InitialValues);
    };

    const handleClose = () => {
        close();
    };

    return (
        <EsmsDialog
            open={open}
            onClose={handleClose}
            title={title}
            onRendered={handleReset}
            onConfirm={formik.handleSubmit}
            disabled={formik.isSubmitting || equipment.length === 0}
            confirmText="Update"
        >
            <div className={classes.formColumn}>
                <div className={classes.labelColumn}>
                    <div className={classes.labelHeader}>
                        <img src="/assets/images/equipmentTreeIcon.svg" alt="Equipment Icon" />
                        <span>Use Existing Equipment</span>
                    </div>
                    <div className={classes.labelContent}>
                        <p>
                            Select an existing piece of equipment.
                        </p>
                    </div>
                </div>
                <div className={classes.inputColumn}>
                    <div className={classes.inputs}>
                        <FormControl className={classes.inputWrapper}>
                            {
                                equipment.length === 0 &&
                                <span>No equipment available.</span>
                            }
                            {
                                equipment.length > 0 &&
                                <React.Fragment>
                                    <InputLabel
                                        htmlFor="equipment"
                                        classes={{
                                            error:   classes.error,
                                            focused: classes.labelFocused,
                                            root:    classes.label
                                        }}
                                        error={Boolean(formik.errors.equipment) && Boolean(formik.touched.equipment)}
                                    >
                                        Equipment
                                    </InputLabel>
                                    <Select
                                        name="equipment"
                                        id="equipment"
                                        value={formik.values.equipment}
                                        onChange={formik.handleChange}
                                        classes={{
                                            root: classes.select
                                        }}
                                        inputProps={{
                                            onBlur: formik.handleBlur
                                        }}
                                        error={Boolean(formik.errors.equipment) && Boolean(formik.touched.equipment)}
                                    >
                                        {
                                            equipment.map(item =>
                                                <MenuItem
                                                    key={item.id}
                                                    value={item.id}
                                                >
                                                    {item.name}
                                                </MenuItem>
                                            )
                                        }
                                    </Select>
                                    {formik.touched.equipment &&
                                     formik.errors.equipment && <FormHelperText className={classes.error}>{formik.errors.equipment}</FormHelperText>}
                                </React.Fragment>
                            }
                        </FormControl>
                    </div>
                </div>
            </div>
        </EsmsDialog>
    );
};

UseExistingEquipmentModal.defaultProps = {
    close:     () => {},
    device:    {},
    equipment: [],
    open:      false,
    title:     ''
};

UseExistingEquipmentModal.propTypes = {
    close:     func,
    device:    object,
    equipment: array,
    open:      bool,
    title:     string
};

const mapStateToProps = state => {
    return {
        equipment: state.architect.equipment
    };
};

const mapDispatchToProps = {
    ...WizardActions
};

export default connect(mapStateToProps, mapDispatchToProps)(UseExistingEquipmentModal);
